// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._189e1dm9{border-width:var(--ds-border-width-selected,2px)}\n._189ee4h9{border-width:var(--ds-border-width,1px)}\n._1dqonqa1{border-style:solid}\n._1h6d1l7x{border-color:var(--ds-border,#0b120e24)}\n._1h6d1w55{border-color:var(--ds-border-accent-blue,#357de8)}\n._4t3i1f4h{height:28px}", ""]);
// Exports
module.exports = exports;
